/** @lintignore */
export enum BrandURL {
  finn = "finn.no",
  FINN = "finn.no",
  dba = "dba.dk",
  DBA = "dba.dk",
  blocket = "blocket.se",
  BLOCKET = "blocket.se",
  tori = "tori.fi",
  TORI = "tori.fi",
  vend = "vend.com",
}
